// extracted by mini-css-extract-plugin
module.exports = {"search_box":"SearchBar_search_box__2Im-z","input_search":"SearchBar_input_search__2zp87","btn_search":"SearchBar_btn_search__2NSDD"};